import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { useLayoutEffect } from 'react';
import { useAuth } from 'react-oidc-context';

import { useDarkMode } from '@/app/hooks/use-dark-mode';
import { AppProvider } from '@/app/provider';
import { RootNotFound } from '@/shared/components/root-not-found';
import { DashboardLayout } from '@/shared/layouts/dashboard-layout';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient; auth: ReturnType<typeof useAuth> }>()({
  component: RootComponent,
  notFoundComponent: RootNotFound
});

function RootComponent() {
  const { isDarkMode } = useDarkMode();

  useLayoutEffect(() => {
    document.documentElement.classList.toggle('dark', isDarkMode);
  }, [isDarkMode]);

  return (
    <AppProvider>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </AppProvider>
  );
}
